import { render, staticRenderFns } from "./TreasuryOutcome.vue?vue&type=template&id=8c0d44b0"
import script from "./TreasuryOutcome.vue?vue&type=script&lang=js"
export * from "./TreasuryOutcome.vue?vue&type=script&lang=js"
import style0 from "./TreasuryOutcome.vue?vue&type=style&index=0&id=8c0d44b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports